module.exports = __webpack_public_path__ + "img/wallet-copy-clipboard.4724e6fa.svg";